import { __decorate } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
//import LiquorTree from 'liquor-tree';
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import ProductsModule from "@/store/modules/productsApps.module";
import { ProductsaddModel } from "@/store/models/productsApps/ProductaddDTO";
import Switches from "vue-switches";
setInteractionMode("passive");
let Products = /** @class */ (() => {
    let Products = class Products extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Add Product";
            this.ctaButtons = [
                {
                    routeName: "Products",
                },
            ];
            this.items = [
                {
                    text: "Add Product",
                },
                {
                    text: "Add",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedProduct = new ProductsaddModel();
        }
        // CRUD
        saveProduct() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    ProductsModule.AddNewProduct(this.selectedProduct).then((response) => {
                        this.$router.push({ name: "Products" });
                    });
                }
            });
        }
        cancelProduct() {
            this.selectedProduct = new ProductsaddModel();
            this.selectedProduct = Object.assign({}, this.selectedProduct);
            this.$router.push({ name: "Products" }),
                (this.selectedProduct = {
                    id: this.selectedProduct.id,
                    name: this.selectedProduct.name,
                    description: this.selectedProduct.description,
                    owner: this.selectedProduct.owner,
                    startedYear: this.selectedProduct.startedYear,
                    domain: this.selectedProduct.domain,
                    status: this.selectedProduct.status,
                });
        }
        // COMPUTED
        get product() {
            return ProductsModule.product;
        }
        // LIFECYCLE
        created() {
            var productId = Guid.parse(this.$route.params.productId);
            ProductsModule.AddNewProduct(this.selectedProduct).then((response) => {
                this.pageIsLoading = false;
                this.selectedProduct = new ProductsaddModel();
                this.selectedProduct = {
                    id: this.product.id,
                    name: this.product.name,
                    description: this.product.description,
                    owner: this.product.owner,
                    startedYear: this.product.startedYear,
                    domain: this.product.domain,
                    status: this.product.status,
                };
            });
        }
    };
    Products = __decorate([
        Component({
            name: "AddProducts",
            components: {
                Layout,
                PageHeader,
                Switches,
            },
        })
    ], Products);
    return Products;
})();
export default Products;
